// Звук рыбалки.
// ПРИОРИТЕТ — реальные файлы с CDN: {document.cloud}sound/fishing/<имя>.ogg|mp3
//   reel     — катушка, подмотка (ЛУЧШЕ ЛУП: играет пока тянешь, скорость = темп)
//   lineout  — стравливание лески (луп, пока зажата ЛКМ)
//   bite     — поклёвка (one-shot)
//   alert    — сигнал «подсекай» (one-shot)
//   creak    — скрип лески под нагрузкой (one-shot, повторяется)
//   snap     — обрыв (one-shot)
//   catch    — улов (one-shot)
//   water    — вода-эмбиент (луп)
// Если файла нет — на его месте работает синтез Web Audio (фолбэк).
let ctx = null;
const AC = () => {
    if (!ctx) {
        const C = window.AudioContext || window.webkitAudioContext;
        if (!C) return null;
        ctx = new C();
        decodePending(); // скачанное до появления контекста — декодируем сейчас
    }
    if (ctx.state === 'suspended') ctx.resume();
    return ctx;
};

// ---------- файлы ----------
// Источники по порядку: 1) локально из сборки клиента (interface/sounds/fishing/,
// в дев-сервере — public/sounds/fishing/), 2) CDN cloud/sound/fishing/.
// ЗАГРУЗКА (fetch) идёт сразу при буте CEF — без AudioContext и жеста юзера;
// декодирование — как только появится контекст. К моменту рыбалки всё в памяти.
const raw = {};      // имя -> ArrayBuffer (скачано)
const buffers = {};  // имя -> AudioBuffer (декодировано)
let loadStarted = false;

const decodePending = () => {
    if (!ctx) return;
    for (const k of Object.keys(raw)) {
        if (buffers[k] || !raw[k]) continue;
        const ab = raw[k]; raw[k] = null;
        ctx.decodeAudioData(ab).then((b) => { buffers[k] = b; }).catch(() => {});
    }
};

export const loadSounds = () => {
    if (loadStarted) { decodePending(); return; }
    loadStarted = true;
    const bases = [
        'sounds/fishing/', // рядом с index.html (CopyPlugin кладёт в interface/sounds)
        (document.cloud || 'https://cdn.just-rp.online/cdn-ra3.ragemp.pro/cloud/') + 'sound/fishing/',
    ];
    ['reel', 'lineout', 'bite', 'alert', 'creak', 'snap', 'catch', 'water'].forEach(async (k) => {
        for (const base of bases) {
            for (const ext of ['ogg', 'mp3']) {
                try {
                    const r = await fetch(base + k + '.' + ext);
                    if (!r.ok) continue;
                    raw[k] = await r.arrayBuffer();
                    decodePending();
                    return;
                } catch (e) {}
            }
        }
    });
};
// предзагрузка с бута CEF (модуль импортируется в бандле при старте)
try { loadSounds(); } catch (e) {}

// lpFreq — лоупас для «смягчения» жёстких записей; мягкая атака против щелчков
const playBuf = (key, vol = 0.5, rate = 1, lpFreq = 0) => {
    const c = AC(); if (!c || !buffers[key]) return false;
    const t = c.currentTime;
    const src = c.createBufferSource();
    src.buffer = buffers[key]; src.playbackRate.value = rate;
    const g = c.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.setTargetAtTime(vol, t, 0.025);
    let head = src;
    if (lpFreq) {
        const lp = c.createBiquadFilter();
        lp.type = 'lowpass'; lp.frequency.value = lpFreq; lp.Q.value = 0.5;
        src.connect(lp); head = lp;
    }
    head.connect(g); g.connect(c.destination);
    src.start();
    return true;
};

// Луп НЕ перезапускается на каждый прокрут колеса: пока крутишь — играет дальше,
// меняется только скорость/громкость. Между «сессиями» продолжаем с того же места
// файла (offset), старт/стоп — с коротким фейдом, чтобы не щёлкало.
const mkLoop = (key, baseGain, lpFreq = 0) => {
    let src = null, g = null, startedAt = 0, offset = 0;
    const stop = () => {
        if (!src) return;
        const c = ctx;
        if (c && g) {
            // запоминаем позицию в файле и мягко гасим
            offset = (offset + (c.currentTime - startedAt)) % (buffers[key] ? buffers[key].duration : 1);
            const s = src, gg = g;
            gg.gain.setTargetAtTime(0.0001, c.currentTime, 0.03);
            setTimeout(() => { try { s.stop(); } catch (e) {} }, 120);
        } else { try { src.stop(); } catch (e) {} }
        src = null; g = null;
    };
    return {
        // вернёт false если файла нет (зовущий включает синтез-фолбэк)
        set(active, rate = 1, vol = 1) {
            const c = AC();
            if (!c || !buffers[key]) { stop(); return false; }
            if (active && !src) {
                src = c.createBufferSource();
                src.buffer = buffers[key]; src.loop = true; src.playbackRate.value = rate;
                g = c.createGain();
                g.gain.setValueAtTime(0.0001, c.currentTime);
                g.gain.setTargetAtTime(baseGain * vol, c.currentTime, 0.04); // мягкий вход
                let head = src;
                if (lpFreq) {
                    const lp = c.createBiquadFilter();
                    lp.type = 'lowpass'; lp.frequency.value = lpFreq; lp.Q.value = 0.5;
                    src.connect(lp); head = lp;
                }
                head.connect(g); g.connect(c.destination);
                startedAt = c.currentTime;
                src.start(0, offset % src.buffer.duration); // продолжаем где остановились
            } else if (active && src) {
                src.playbackRate.value = rate;
                g.gain.setTargetAtTime(baseGain * vol, c.currentTime, 0.05);
            } else if (!active) stop();
            return true;
        },
        stop,
    };
};

// ---------- синтез-фолбэк ----------
let noiseBuf = null;
const getNoise = (c) => {
    if (noiseBuf) return noiseBuf;
    noiseBuf = c.createBuffer(1, c.sampleRate * 1.2, c.sampleRate);
    const d = noiseBuf.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
    return noiseBuf;
};

const click = (freq, vol, len = 0.018, q = 3) => {
    const c = AC(); if (!c) return;
    const t = c.currentTime;
    const src = c.createBufferSource();
    src.buffer = getNoise(c);
    src.playbackRate.value = 0.9 + Math.random() * 0.2;
    const bp = c.createBiquadFilter();
    bp.type = 'bandpass'; bp.frequency.value = freq * (0.95 + Math.random() * 0.1); bp.Q.value = q;
    const g = c.createGain();
    g.gain.setValueAtTime(vol, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + len);
    src.connect(bp); bp.connect(g); g.connect(c.destination);
    src.start(t, Math.random() * 0.8, len + 0.02);
};

const synthBite = () => {
    const c = AC(); if (!c) return;
    const t = c.currentTime;
    const o = c.createOscillator();
    o.type = 'sine';
    o.frequency.setValueAtTime(520, t);
    o.frequency.exponentialRampToValueAtTime(140, t + 0.12);
    const g = c.createGain();
    g.gain.setValueAtTime(0.16, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.16);
    o.connect(g); g.connect(c.destination);
    o.start(t); o.stop(t + 0.18);
    const src = c.createBufferSource(); src.buffer = getNoise(c);
    const bp = c.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 3200; bp.Q.value = 0.8;
    const g2 = c.createGain();
    g2.gain.setValueAtTime(0.05, t + 0.02);
    g2.gain.exponentialRampToValueAtTime(0.0001, t + 0.3);
    src.connect(bp); bp.connect(g2); g2.connect(c.destination);
    src.start(t + 0.02, Math.random() * 0.5, 0.35);
};

const synthAlert = () => {
    const c = AC(); if (!c) return;
    const t = c.currentTime;
    [660, 880].forEach((f, i) => {
        const o = c.createOscillator(); o.type = 'triangle';
        o.frequency.value = f;
        const g = c.createGain();
        g.gain.setValueAtTime(0.0001, t + i * 0.09);
        g.gain.exponentialRampToValueAtTime(0.08, t + i * 0.09 + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t + i * 0.09 + 0.12);
        o.connect(g); g.connect(c.destination);
        o.start(t + i * 0.09); o.stop(t + i * 0.09 + 0.14);
    });
};

// «трескание дерева» под нагрузкой: кластер коротких сухих щелчков-трещин
// + низкий глухой отклик корпуса. Чем сильнее натяг — тем плотнее и злее треск.
const synthCreak = (load01) => {
    const c = AC(); if (!c) return;
    const t0 = c.currentTime;
    const cracks = 2 + Math.round(load01 * 4 + Math.random() * 2); // 2..8 трещинок
    let at = t0;
    for (let i = 0; i < cracks; i++) {
        at += 0.012 + Math.random() * (0.07 - load01 * 0.04); // плотнее при нагрузке
        // сухой щелчок древесины
        const src = c.createBufferSource();
        src.buffer = getNoise(c);
        src.playbackRate.value = 0.8 + Math.random() * 0.5;
        const bp = c.createBiquadFilter();
        bp.type = 'bandpass';
        bp.frequency.value = 700 + Math.random() * 900 + load01 * 500;
        bp.Q.value = 1.1 + Math.random() * 1.2; // широкий = деревянный, не звонкий
        const g = c.createGain();
        const v = (0.04 + load01 * 0.07) * (0.5 + Math.random() * 0.6);
        g.gain.setValueAtTime(v, at);
        g.gain.exponentialRampToValueAtTime(0.0001, at + 0.012 + Math.random() * 0.014);
        src.connect(bp); bp.connect(g); g.connect(c.destination);
        src.start(at, Math.random() * 0.9, 0.05);
    }
    // глухой «корпусный» отклик удилища
    const o = c.createOscillator();
    o.type = 'sine';
    const f = 95 + Math.random() * 40 + load01 * 30;
    o.frequency.setValueAtTime(f, t0);
    o.frequency.exponentialRampToValueAtTime(f * 0.75, t0 + 0.12);
    const g2 = c.createGain();
    g2.gain.setValueAtTime(0.0001, t0);
    g2.gain.exponentialRampToValueAtTime(0.025 + load01 * 0.045, t0 + 0.015);
    g2.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.16);
    o.connect(g2); g2.connect(c.destination);
    o.start(t0); o.stop(t0 + 0.18);
};

const synthSnap = () => {
    const c = AC(); if (!c) return;
    const t = c.currentTime;
    const src = c.createBufferSource(); src.buffer = getNoise(c);
    const hp = c.createBiquadFilter(); hp.type = 'highpass'; hp.frequency.value = 1800;
    const g = c.createGain();
    g.gain.setValueAtTime(0.3, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.08);
    src.connect(hp); hp.connect(g); g.connect(c.destination);
    src.start(t, 0.1, 0.1);
    const o = c.createOscillator(); o.type = 'sine';
    o.frequency.setValueAtTime(220, t + 0.06);
    o.frequency.exponentialRampToValueAtTime(70, t + 0.5);
    const g2 = c.createGain();
    g2.gain.setValueAtTime(0.12, t + 0.06);
    g2.gain.exponentialRampToValueAtTime(0.0001, t + 0.55);
    o.connect(g2); g2.connect(c.destination);
    o.start(t + 0.06); o.stop(t + 0.6);
};

const synthCatch = () => {
    const c = AC(); if (!c) return;
    const t = c.currentTime;
    const src = c.createBufferSource(); src.buffer = getNoise(c);
    const bp = c.createBiquadFilter(); bp.type = 'bandpass'; bp.Q.value = 0.7;
    bp.frequency.setValueAtTime(800, t);
    bp.frequency.exponentialRampToValueAtTime(4200, t + 0.25);
    const g = c.createGain();
    g.gain.setValueAtTime(0.14, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + 0.45);
    src.connect(bp); bp.connect(g); g.connect(c.destination);
    src.start(t, Math.random() * 0.5, 0.5);
    [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => {
        const o = c.createOscillator(); o.type = 'sine'; o.frequency.value = f;
        const g2 = c.createGain();
        const at = t + 0.12 + i * 0.085;
        g2.gain.setValueAtTime(0.0001, at);
        g2.gain.exponentialRampToValueAtTime(0.07, at + 0.02);
        g2.gain.exponentialRampToValueAtTime(0.0001, at + 0.5);
        o.connect(g2); g2.connect(c.destination);
        o.start(at); o.stop(at + 0.55);
    });
};

// ---------- публичный API (файл или синтез) ----------
const reelLoop = mkLoop('reel', 0.55);
const lineLoop = mkLoop('lineout', 0.3, 2400);  // мягче: тише + лоупас
const waterLoop = mkLoop('water', 0.16);
let clickAcc = 0, outAcc = 0;

// каждый кадр: скорость подмотки 0..1
export const tickReel = (speed01, dt) => {
    const active = speed01 > 0.02;
    if (reelLoop.set(active, 0.7 + speed01 * 0.8, 0.35 + speed01 * 0.65)) return;
    if (!active) return;
    clickAcc += speed01 * dt * 26;
    if (clickAcc > 1) { clickAcc = 0; click(2300 + speed01 * 1800, 0.05 + speed01 * 0.06, 0.014, 4); }
};

// каждый кадр: стравливание вкл/выкл
export const tickLineOut = (active, dt) => {
    if (lineLoop.set(active, 1, 1)) return;
    if (!active) return;
    outAcc += dt;
    if (outAcc > 0.07) { outAcc = 0; click(900, 0.045, 0.025, 2.2); }
};

export const stopLoops = () => { reelLoop.stop(); lineLoop.stop(); waterLoop.stop(); };

export const playBite = () => { if (!playBuf('bite', 0.5)) synthBite(); };
export const playAlert = () => { if (!playBuf('alert', 0.4)) synthAlert(); };
// «струна натягивается»: чем сильнее натяг, тем выше тон и громче; мягко (лоупас)
export const playCreak = (load01) => {
    if (!playBuf('creak', 0.14 + load01 * 0.26, 0.8 + load01 * 0.55, 2600)) synthCreak(load01);
};
// успех/провал: В ИГРЕ звучат штатные звуки мода (клиент играет их по
// client.fishing.minigame.end) — CEF молчит, чтобы не дублировать.
// Синтез остаётся только для браузерного превью.
export const playSnap = () => {
    if (window.mp !== undefined) return;
    if (!playBuf('snap', 0.55)) synthSnap();
};
export const playCatch = () => {
    if (window.mp !== undefined) return;
    if (!playBuf('catch', 0.5)) synthCatch();
};

export const startWater = () => {
    if (waterLoop.set(true, 1, 1)) return () => waterLoop.stop();
    // синтез-фолбэк
    const c = AC(); if (!c) return () => {};
    const src = c.createBufferSource();
    src.buffer = getNoise(c); src.loop = true; src.playbackRate.value = 0.55;
    const lp = c.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 480; lp.Q.value = 0.4;
    const g = c.createGain(); g.gain.value = 0.018;
    const lfo = c.createOscillator(); lfo.frequency.value = 0.17;
    const lg = c.createGain(); lg.gain.value = 0.008;
    lfo.connect(lg); lg.connect(g.gain);
    src.connect(lp); lp.connect(g); g.connect(c.destination);
    src.start(); lfo.start();
    return () => { try { src.stop(); lfo.stop(); } catch (e) {} };
};
